import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

const buttonDefaults = {
  flex: 1,
  border: `1px solid ${colour.grey[500]}`,
  borderRadius: 0,
  fontSize: 16,
  fontWeight: 600,
  textAlign: 'center',
  padding: 10,
  cursor: 'pointer'
}

export const styles = StyleSheet.create({
  itemWrapper: {
    display: 'flex',
    position: 'relative',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '0 20px 15px',
    ':last-child': {
      paddingBottom: 25
    }
  },
  alert: {
    flex: 4
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[100],
    background: colour.grey[500],
    padding: 10,
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: '4px 4px 0 0',
    ':before': {
      fontFamily: 'informetis',
      fontSize: 20,
      fontWeight: 400,
      content: '"\\E80F"',
      display: 'inline-block',
      paddingRight: 5
    }
  },
  warning: {
    background: colour.assisted.primaryGradientTop,
    border: `1px solid ${colour.assisted.primaryGradientTop}`,
    ':after': {
      background: colour.assisted.primaryGradientTop,
      borderColor: colour.assisted.primaryGradientTop
    }
  },
  emergency: {
    color: '#ffffff',
    background: colour.brand.red,
    border: `1px solid ${colour.brand.red}`,
    ':after': {
      background: colour.brand.red,
      borderColor: colour.brand.red
    }
  },
  headerClosed: {
    background: '#ffffff',
    border: `1px solid ${colour.grey[500]}`,
    color: colour.grey[100],
    borderRadius: 4,
    ':after': {
      background: '#ffffff',
      borderColor: colour.grey[500]
    }
  },
  headerTitle: {
    flex: 1
  },
  headerToggleShow: {
    flex: 1,
    textAlign: 'right',
    fontSize: 14,
    textDecoration: 'underline',
    ':after': {
      display: 'inline-block',
      fontFamily: 'informetis',
      fontWeight: 600,
      content: '"\\f107"',
      paddingLeft: 10,
      textDecoration: 'none',
      overflow: 'hidden',
      height: 12
    }
  },
  headerToggleHide: {
    flex: 1,
    textAlign: 'right',
    fontSize: 14,
    textDecoration: 'underline',
    ':after': {
      display: 'inline-block',
      fontFamily: 'informetis',
      fontWeight: 600,
      content: '"\\f106"',
      paddingLeft: 10,
      textDecoration: 'none',
      overflow: 'hidden',
      height: 12
    }
  },
  body: {
    borderLeft: `1px solid ${colour.grey[500]}`,
    borderRight: `1px solid ${colour.grey[500]}`
  },
  bodyTitle: {
    color: colour.grey[100],
    fontWeight: 600,
    fontSize: 16,
    padding: '20px 15px 0',
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    color: colour.grey[200],
    maxWidth: 20,
    marginRight: 15
  },
  bodyText: {
    color: colour.grey[200],
    fontSize: 14,
    padding: 15,
    display: 'block'
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  paddedContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 10,
    border: `1px solid ${colour.grey[500]}`
  },
  correctContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 10,
    border: `1px solid ${colour.grey[500]}`,
    color: colour.grey[200],
    fontWeight: 600,
    ':before': {
      fontFamily: 'informetis',
      fontSize: 20,
      fontWeight: 400,
      content: '"\\F164"',
      display: 'inline-block',
      paddingRight: 10,
      color: colour.brand.green
    }
  },
  incorrectContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 10,
    border: `1px solid ${colour.grey[500]}`,
    color: colour.grey[200],
    fontWeight: 600,
    ':before': {
      fontFamily: 'informetis',
      fontSize: 20,
      fontWeight: 400,
      content: '"\\F165"',
      display: 'inline-block',
      paddingRight: 10,
      color: colour.brand.red
    }
  },
  incorrectButton: {
    ...buttonDefaults,
    color: colour.brand.red,
    borderRadius: '0 0 0 4px',
    ':before': {
      fontFamily: 'informetis',
      fontSize: 20,
      fontWeight: 400,
      content: '"\\F165"',
      display: 'inline-block',
      paddingRight: 10
    }
  },
  correctButton: {
    ...buttonDefaults,
    borderLeft: 0,
    color: colour.brand.green,
    borderRadius: '0 0 4px 0',
    ':before': {
      fontFamily: 'informetis',
      fontSize: 20,
      fontWeight: 400,
      content: '"\\F164"',
      display: 'inline-block',
      paddingRight: 10
    }
  },
  buttonGreen: {
    width: '100%',
    padding: 10,
    display: 'block',
    color: '#ffffff',
    textDecoration: 'none',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 18,
    border: 0,
    borderRadius: 30,
    cursor: 'pointer',
    background: colour.brand.green
  }
});
